module.exports = __webpack_public_path__ + "img/overview-light.2376f1b2.svg";